/**
 * Feature Flag 定数
 */
export const FEATURE_FLAG = {
  /** 動的マッピング機能 */
  FA_DYNAMIC_MAPPING_V1: 'release.fa.dynamic_mapping_v1',
  /**  固定資産除却 */
  FA_RETIRE_V1: 'release.fa.fixed_asset_retire_v1',
  /** 申請明細照会 */
  FA_REQUEST_DETAIL_REFERENCE_V1: 'release.fa.request_detail_reference_v1',
  /** リース物件情報変更(取込) */
  LA_ARTICLE_INFO_CHANGE_IMPORT_V1: 'release.la.la_article_info_change_import_v1',
  /** リース残高移行削除(1件別) */
  LA_MIGRATION_INDIVIDUAL_DELETE_V1: 'release.la.migration_individual_delete_v1',
} as const;
